import script from "./PaymentDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./PaymentDetail.vue?vue&type=script&setup=true&lang=js"

import "./PaymentDetail.vue?vue&type=style&index=0&id=68d96148&lang=css"

const __exports__ = script;

export default __exports__